<template>
  <div class="calendar">
    <page-title title="Agenda" description="Overzicht van alle events."></page-title>
    <router-link to="/new-event/new" class="btn btn-success btn-lg mb-3">+ event toevoegen</router-link>

    <div id="document-table" v-if="events.length">
      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th>van</th>
            <th>tot</th>
            <th>Titel</th>
            <th>type</th>
            <th>locatie</th>
            <th>bestand</th>
            <th>status</th>
            <th>acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in events" :key="item.id">
            <td>
              <DateFormat :date="item.date_start" day time></DateFormat>
            </td>
            <td>
              <DateFormat :date="item.date_end" day time></DateFormat>
            </td>
            <td>{{item.title}}</td>
            <td>{{item.type}}</td>
            <td>{{item.location}}</td>
            <td>
              <span
                v-if="item.files && item.files.length>0"
              >{{item.files[0].filename.substring(10)}}</span>
              <span v-if="!item.files || item.files.length == 0">-</span>
            </td>
            <td>
              <button
                class="btn btn-sm btn-success"
                v-if="item.status=='live'"
                @click="toggleStatus(item)"
              >{{item.status == 'live' ? 'gepubliceerd' : 'concept'}}</button>
              <button
                class="btn btn-sm btn-warning"
                v-if="item.status!='live'"
                @click="toggleStatus(item)"
              >{{item.status}}</button>
            </td>
            <td>
              <router-link :to=" { name: 'new-event', params: {id: item.id, cid: cid} }">
                <Icon icon="pencil" title="aanpassen" success></Icon>
              </router-link>
              <Icon icon="trash" title="verwijder" v-on:clicked="deleteItem(index)" danger></Icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!events || !events.length">Klik op de groene knop om events toe te voegen.</div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
var firestorage = fb.firestorage;

import PageTitle from "@/components/PageTitle.vue";
import DateFormat from "@/components/DateFormat.vue";
import Icon from "@/components/icon.vue";

export default {
  name: "Calendar",
  components: {
    PageTitle,
    DateFormat,
    Icon
  },
  data() {
    return {
      events: [],
      cid: this.$cookies.get("company")
    };
  },
  methods: {
    deleteItem(index) {
      this.$confirm({
        message: `Weet je zeker dat je dit item wilt verwijderen?`,
        button: {
          no: "annuleren",
          yes: "verwijderen"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            // eerst de bestanden
            var files = this.events[index].files;
            if (files) {
              files.forEach(img =>
                img.filename == ""
                  ? (img = 1.721)
                  : firestorage
                      .ref("events/" + this.cid + "/" + img.filename)
                      .delete()
                      .catch(error => {
                        console.error(`file delete error occured: ${error}`);
                      })
              );
            }
            var id = this.events[index].id;
            fb.companiesCollection
              .doc(this.cid)
              .collection("calendar")
              .doc(id)
              .delete()
              .then(() => this.events.splice(index, 1))
              .catch(function(e) {
                alert("Kon niet verwijderd worden");
                // TODO toast message
                console.log(e.message);
              });
          }
        }
      });
    },
    toggleStatus(item) {
      var status =
        item.status == "live"
          ? (item.status = "concept")
          : (item.status = "live");
      var id = item.id;
      fb.companiesCollection
        .doc(this.cid)
        .collection("calendar")
        .doc(id)
        .update({ status: status })
        .then(() => (item.status = status))
        .catch(function(e) {
          alert("Kon niet aangepast worden");
          // TODO toast message
          console.log(e.message);
        });

      if (status !== "live") {
        return;
      }
      this.$confirm({
        message: `Wil je nu een automatische pushnotificatie sturen?`,
        button: {
          no: "overslaan",
          yes: "verzenden"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          var now = new Date();
          fb.notificationsCollection
            .add({
              type: "event",
              refid: id,
              date: now,
              created_by: this.$cookies.get("user"),
              title: item.title,
              message:
                "Er is een nieuw event in de agenda geplaatst. Je vindt dit in de kalender.",
              establishments: item.establishments,
              positions: item.positions,
              hidden: true,
              company: this.$cookies.get("company"),
              sendPush: confirm
            })
            .catch(error => console.log(error));
        }
      });
    }
  },
  created() {
    fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection("calendar")
      .orderBy("date_start", "desc")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          let d = doc.data();
          const data = {
            id: doc.id,
            canComment: d.can_comment,
            dateCreated: d.date_created, // new Date(d.date_created),
            files: d.files,
            title: d.title,
            content: d.content,
            status: d.status,
            type: d.type,
            date_end: d.date_end,
            date_start: d.date_start,
            location: d.location,
            establishments: d.establishments,
            positions: d.positions
          };
          this.events.push(data);
        });
      });
  }
};
</script>
